import { createRoot } from 'react-dom/client'
import './index.css'
import './style/main.scss'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'
import './utils/i18n';
import "@fontsource/manrope/400.css"; // regular
import "@fontsource/manrope/500.css"; // medium
import "@fontsource/manrope/700.css"; // bold

createRoot(document.getElementById('root')!).render(

    <BrowserRouter>
       <App />
    </BrowserRouter>
)
